import React from 'react';
import Loader from "../../Loader";

export default () => <Loader/>;